import ReactDOM from 'react-dom';
import * as mobx from 'mobx';

import 'bootstrap/dist/css/bootstrap.css';
import './styles/fonts.css';
import './styles/animations.css';
import './styles/global.css';

import { AppStore } from './stores/app.store';
import { library } from '@fortawesome/fontawesome-svg-core';
import { iconList } from './styles/icons';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { HomePage } from './pages/home.page';
import { LoadingOverlay } from './components/loading-overlay.component';
import { observer } from 'mobx-react-lite';
import { Header } from './components/header.component';
import { NoAuction } from './pages/no-auction.page';
import { ArtistsPage } from './pages/artists.page';
import { AboutPage } from './pages/about.page';
import { BecomeArtist } from './pages/become-artist';
library.add(...iconList);

// TODO: this is debug configuration
mobx.configure({
    enforceActions: 'always',
    computedRequiresReaction: true,
    reactionRequiresObservable: true,
    observableRequiresReaction: true,
    disableErrorBoundaries: true
});

// TODO: development debugging only
// @ts-ignore For easier debugging
window._____APP_STATE_____ = AppStore;

AppStore.loadAppData();

const App = observer(() => (
    <BrowserRouter>
        <LoadingOverlay show={!AppStore.appLoaded} />
        <div className="content-container bg-grid">
            <Switch>
                <Route path="/artists">
                    <div className="h-100 d-flex flex-column">
                        <Header />
                        <div className="flex-grow-1 overflow-auto">
                            <ArtistsPage />
                        </div>
                    </div>
                </Route>
                <Route path="/about">
                    <div className="h-100 d-flex flex-column">
                        <Header />
                        <div className="flex-grow-1 overflow-auto">
                            <AboutPage />
                        </div>
                    </div>
                </Route>
                <Route path="/become-an-artist">
                    <div className="h-100 d-flex flex-column">
                        <Header />
                        <div className="flex-grow-1 overflow-auto">
                            <BecomeArtist />
                        </div>
                    </div>
                </Route>
                <Route path="/">
                    {(AppStore.auctionStore.auctionData)
                        ? <HomePage />
                        : <NoAuction upcomingDate={AppStore.auctionStore.upcomingDate} />
                    }
                </Route>
            </Switch>
        </div>
    </BrowserRouter>
));

ReactDOM.render(<App />, document.getElementById('root'));